<template>
	<div>
		<h4 class="b-modal__title" v-html="loc.SOA_ORDER_MODAL_A_PRODUCT_TITLE"></h4>
		<div class="b-modal__subtitle"></div>
		<div class="b-product__list b-modal__list">
			<citrus-product-popup-item v-for="item in params.productList" :key="item.id"
			                           :product="item"></citrus-product-popup-item>
		</div>
	</div>
</template>

<script>
import {Vue} from "ui.vue";
import CitrusProductPopupItem from "./product/CitrusProductPopupItem.vue"

export default {
	name: "PopupAdditionalProduct",
	components: {
		CitrusProductPopupItem
	},
	props: {
		params: {
			type: [Array, Object],
			default: () => {
				return {
					productList: [],
				}
			}
		},
	},
	computed: {
		loc() {
			return Object.freeze(Vue.getFilteredPhrases("SOA_ORDER_MODAL_A_PRODUCT_"));
		}
	}
}
</script>